import UpdateVendorNoteForm from './form/UpdateVendorNoteForm';
import CreateVendorNoteForm from './form/CreateVendorNoteForm';
import { CREATE_VENDOR_NOTE_PERMISSION } from './useVendorNoteService';
import NoteTimelineRecordLayout from './shared/NoteTimelineRecordLayout/VendorNoteTimelineRecordLayout';

const useVendorNoteRegistry = () => ({
  AddForm: CreateVendorNoteForm,
  UpdateForm: UpdateVendorNoteForm,
  isApplicable: (item: any) => !!item.note,
  source: 'note',
  urlPostfix: 'notes',
  RecordLayout: NoteTimelineRecordLayout,
  name: 'Note',
  permissionToCheck: CREATE_VENDOR_NOTE_PERMISSION,
});

export default useVendorNoteRegistry;
